import React from 'react';
import type { BannerTypes } from '@gin-betting/banners';
import { App } from '@gin-betting/core';

import {
    PromoMatchOdds,
    SmartLink,
    TopBannerMatchInfo,
    TopBannerCompetitorInfo,
} from 'components';
import useColorfulBanner from './useColorfulBanner';
import { AsyncOddButton } from 'modules/betslip/async';
import './colorfulBanner.scss';

interface Props {
    banner: BannerTypes.BannerItem;
}

const ColorfulBanner: React.FC<Props> = ({ banner }) => {
    const { id: matchId } = banner;

    const {
        competitors,
        market,
        match,
        tournament,
        route,
        isLive,
    } = useColorfulBanner({
        matchId,
    });

    const { awayName, awayLogo, homeLogo, homeName } = competitors;

    return (
        <div styleName="container">
            <SmartLink
                to={`${route}${App.Routes.MATCH}${match?.slug}`}
                styleName="wrapper"
            >
                <div styleName="competitor">
                    <TopBannerCompetitorInfo
                        withSportLogo={true}
                        sportId={match?.sportId ?? ''}
                        isHome={true}
                        logo={homeLogo}
                        name={homeName}
                    />
                </div>

                <TopBannerMatchInfo
                    tournament={tournament}
                    startTime={match?.startTime}
                    isLive={isLive}
                    route={route}
                    marketName={market?.name ?? ''}
                    score={match?.score}
                    matchId={matchId}
                    sportId={match?.sportId}
                    dateFormat="MMM dd, yyyy"
                />

                <div styleName="competitor">
                    <TopBannerCompetitorInfo
                        withSportLogo={true}
                        sportId={match?.sportId || ''}
                        isHome={false}
                        logo={awayLogo}
                        name={awayName}
                    />
                </div>
            </SmartLink>

            <div styleName="odds">
                <PromoMatchOdds
                    oddIds={market?.odds}
                    OddButton={AsyncOddButton}
                    competitors={competitors}
                />
            </div>
        </div>
    );
};

export default React.memo(ColorfulBanner);
